module.exports = __webpack_public_path__ + "img/feature-illustration-3.2292d9f.svg";